import React, { useState } from "react";

import "./contractPendingBanner.css";
import { useMantenedora } from "../../context/MantenedoraContext";

const DISMISS_KEY = "contractBannerDismissed";

const ContractPendingBanner = () => {
  const { isPlanContractPending } = useMantenedora();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "true"
  );

  if (!isPlanContractPending || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  return (
    <div className="contract-pending-banner" role="status">
      <svg
        className="contract-pending-banner-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span className="contract-pending-banner-text">
        <strong>Contratação em análise.</strong> Nossa equipe entrará em
        contato em até 7 dias úteis para efetivar o contrato.
      </span>
      <button
        className="contract-pending-banner-dismiss"
        onClick={handleDismiss}
        aria-label="Fechar aviso"
        title="Fechar"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default ContractPendingBanner;
